import React from 'react';
import BaseModal from 'src/common/components/Modal';
import notice from 'src/common/components/Notice';
import UtilInputs from 'src/common/components/UtilInputs';
import { editForm } from '../utils/list_data';
import { institutionsAPI } from 'src/api/modules/institutions';

const EditUnit = ({
	open,
	color = 'secondary',
	onClose,
	onSuccess,
	unit,
	onChangeData,
}) => {
	const onSave = () => {
		institutionsAPI
			.institucionCRUD(4, 'UA', unit.nombre, unit.id, unit.prefijo)
			.then(() => {
				onSuccess('Unidad administrativa actualizada', 'success', 2);
			})
			.catch(() => {
				notice('Ha ocurrido un error en su solicitud');
			});
	};

	return (
		<BaseModal
			open={open}
			mainText="Editar Unidad Administrativa"
			onConfirm={onSave}
			confirmLabel="Guardar"
			onClose={onClose}
			onCancel={onClose}
		>
			<UtilInputs
				formValues={unit}
				inputValues={editForm}
				onValuesChange={onChangeData}
			/>
		</BaseModal>
	);
};

export default EditUnit;
